export const NO_MATCH_FOUND_MODAL = "no-match-found-modal";
export const NO_MATCH_FOUND_MODAL_TITLE = "no-match-found-modal-title";
export const NO_MATCH_FOUND_MODAL_MODAL_CONTENT_1 =
  "no-match-found-modal-content-1";
export const CREATE_NEW_APPLICATION_BUTTON = "create-new-application-button";
export const CREATE_NEW_ACCOUNT_BUTTON = "create-new-account-button";
export const FLOW_TEXT_ACCOUNT = "account";
export const FLOW_TEXT_APPLICATION = "application";
export const FIND_A_PROVIDER = "find-provider-link";
export const FIND_A_PROVIDER_BUTTON = "find-provider-button";
